import moment from 'moment';
import { EventStartFilterResponse, EventStartFilterType } from '../../../api/common.generated';

const formatEventStartFilterDate = (numberOfDays: number) => {
	return moment().add(numberOfDays, 'days').local().locale('pl').format('dd. DD.MM');
};

// Only used when frontend is unable to get available filters from the backend due to some error.
export const defaultEventStartFilters: EventStartFilterResponse[] = [
	{
		label: '1h',
		value: '1h',
		type: EventStartFilterType.Time,
	},
	{
		label: '3h',
		value: '3h',
		type: EventStartFilterType.Time,
	},
	{
		label: '6h',
		value: '6h',
		type: EventStartFilterType.Time,
	},
	{
		label: 'Dzisiaj',
		value: '0d',
		type: EventStartFilterType.Date,
	},
	{
		label: 'Jutro',
		value: '1d',
		type: EventStartFilterType.Date,
	},
	{
		label: 'Pojutrze',
		value: '2d',
		type: EventStartFilterType.Date,
	},
	{
		label: formatEventStartFilterDate(3),
		value: '3d',
		type: EventStartFilterType.Date,
	},
	{
		label: formatEventStartFilterDate(4),
		value: '4d',
		type: EventStartFilterType.Date,
	},
	{
		label: formatEventStartFilterDate(5),
		value: '5d',
		type: EventStartFilterType.Date,
	},
	{
		label: formatEventStartFilterDate(6),
		value: '6d',
		type: EventStartFilterType.Date,
	},
	{
		label: formatEventStartFilterDate(7),
		value: '7d',
		type: EventStartFilterType.Date,
	},
	{
		label: formatEventStartFilterDate(8),
		value: '8d',
		type: EventStartFilterType.Date,
	},
	{
		label: formatEventStartFilterDate(9),
		value: '9d',
		type: EventStartFilterType.Date,
	},
];

export const seeMorePopularDefaultValue = 4;
